import { gql, useMutation } from "@apollo/client";
import type { MutationHookOptions } from "@apollo/client";

const TEAM_MEMBER_DESTROY_MUTATION = gql`
  mutation TeamMemberDestroy($id: ID!) {
    destroyTeamMember(teamMemberId: $id) {
      errors
    }
  }
`;

interface TeamMemberDestroyVariables {
  id: string;
}

interface TeamMemberDestroyData {
  destroyTeamMember: {
    errors: string[];
  };
}

const useTeamMemberDestroyMutation = (
  options?: MutationHookOptions<TeamMemberDestroyData, TeamMemberDestroyVariables>,
) => {
  return useMutation<TeamMemberDestroyData, TeamMemberDestroyVariables>(
    TEAM_MEMBER_DESTROY_MUTATION,
    options,
  );
};

export { useTeamMemberDestroyMutation };
export type { TeamMemberDestroyData, TeamMemberDestroyVariables };
